<template>
<div>
  <mv-tabs :tabsHeaders="tabsHeaders" @tabs="tabs = $event">
    <template #leftContainer0>
      <div>
        <ExpenseSearch @search="search"></ExpenseSearch>
      </div>
    </template>
  </mv-tabs>
</div>
</template>
<script>
import ExpenseSearch from './components/ExpenseSearch/ExpenseSearch.vue'
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import MvTabs from './components/MvTabs/MvTabs.vue'
import WorkPCIRepository from '@/shared/http/repositories/pci/workpci.js'
import { loading, toast } from '@/shared/utils/UIHelper'

export default {
  name: 'TravelExpenseZpag',
  components: { ExpenseSearch, MvTabs },
  mixins: [ActionsForm],
  data () {
    return {
      totalDespesas: 0,
      prestacao: false,
      tabs: 0,
      tabsHeaders: []
    }
  },
  mounted () {
    this.verifica()
  },
  methods: {
    verifica () {
      this.tabsHeaders = [
        {title: 'Relatório', icon: 'fas fa-file-contract'}]
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    AtualizaPrestacao (value) {
      this.prestacao = value
    },
    async search (data) {
      loading.push()
      console.log(data)
      await WorkPCIRepository.DownloadStatusReport(data)
        .then(response => {
          const { data, code } = response.data
          if (code === 200) {
            this.onDownloadExcel(data)
          }
        }).catch(error => {
          toast.error(error)
        })
      loading.close()
    },
    onDownloadExcel (obj) {
      const contentType = obj.contentType
      const data = Uint8Array.from(atob(obj.file), c => c.charCodeAt(0))
      var a = window.document.createElement('a')
      a.href = window.URL.createObjectURL(new Blob([data], { type: contentType }))
      a.download = obj.name
      document.body.appendChild(a)
      a.click()
      toast.success('Arquivo gerado com sucesso!')
      loading.close()
    }
  }
}
</script>

<style scoped>
.left-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 125px;
  border-radius: 8px;
}
.title-card-sales {
  font-size: 24px;
  background: #008144;
  padding: 20px;
  border-radius: 8px 8px 0px 0px;
  color: white;
  font-weight: bold;
}
.sales-value {
  width: 100%;
  height: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  font-weight: bold;
  background-color: white;
  border-radius: 0px 0px 8px 8px;
  margin-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/reports/consultstatus/consultstatus.vue